var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apex-chart',{attrs:{"type":"bar","height":"300","options":_vm.options,"series":_vm.ser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }